import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { useTranslation } from 'react-i18next'
import InputField from 'reusableComponents/InputField/InputField'

const Container = styled.div`
  align-items: center;
  gap: 18px;
  .popupMsg {
    margin-top: 18px;
    text-align: center;
  }
  input[type='text'] {
    margin-top: 22px;
    width: 100% !important;
  }
`
const BuzzerCode = ({ onValueChangeHandler, buzzerCode }) => {
  const { t } = useTranslation()
  return (
    <Container>
      <span className="popupMsg">{t('del_date_addr_correction.buzzer_code_popup_msg')}</span>
      <InputField
        id="buzzer-code"
        value={buzzerCode}
        maxLength={6}
        onChange={onValueChangeHandler}
        label={t('deliveryPreferencesSummary.buzzer_code_type')}
      />
    </Container>
  )
}
BuzzerCode.propTypes = {
  onValueChangeHandler: PropTypes.func,
  buzzerCode: PropTypes.string,
}
BuzzerCode.defaultProps = {
  onValueChangeHandler: null,
  buzzerCode: '',
}
export default BuzzerCode
